// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VerticalTabs_wrapper__sEUq0","header":"VerticalTabs_header__3gghk","active":"VerticalTabs_active__2Yvdp","tab":"VerticalTabs_tab__3P7jc"};